export default __webpack_public_path__ + "static/media/flask-logo.03e5176f.svg";